import TooltipIcon from "@/icons/TooltipIcon"
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
    TooltipProvider
  } from "@/components/ui/tooltip"  

interface TooltipWrapperProps {
  content: string
  className?: string
}

export function TooltipWrapper({ content , className}: TooltipWrapperProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <TooltipIcon className={`wysg:h-4 wysg:w-4 wysg:text-gray-500 wysg:inline-block ${className}`} />
        </TooltipTrigger>
        <TooltipContent 
          align="start" 
          side="right" 
          sideOffset={8}
          className="wysg:text-white wysg:rounded-md wysg:px-3 wysg:text-sm wysg:max-w-xs"
        >
          <p className="wysg:text-xs! wysg:text-white! wysg:m-0! wysg:break-words wysg:whitespace-normal">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
} 